export class AzureVmSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "string",
            "format": ""
        },
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<AzureDisk>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureVmSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
